function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.4;fill:#6C63FF;enable-background:new    ;}\n\t.st2{fill:#EFFFB4;}\n\t.st3{fill:#3F3D56;}\n\t.st4{fill:#AAD9FF;}\n\t.st5{fill:#B4CDFF;}\n\t.st6{fill:#2F2E41;}\n\t.st7{fill:#FFB8B8;}\n\t.st8{opacity:0.1;enable-background:new    ;}\n\t.st9{fill:#D0CDE1;}\n\t.st10{fill:#FF9FC2;}\n\t.st11{opacity:0.2;fill:#FF74D6;enable-background:new    ;}\n\t.st12{opacity:0.2;fill:#FF9FC2;enable-background:new    ;}\n\t.st13{fill:#F4FFDF;}\n\t.st14{fill:#E3A3FF;}\n\t.st15{fill:#FFC0CB;}\n\t.st16{fill:url(#SVGID_1_);}\n\t.st17{fill:#6C63FF;}\n\t.st18{fill:#41B883;}\n\t.st19{fill:#35495E;}\n\t.st20{opacity:0.5;}\n\t.st21{fill:url(#SVGID_2_);}\n\t.st22{fill:#FFCDE0;}\n\t.st23{fill:#21609B;}\n\t.st24{fill:url(#SVGID_3_);}\n\t.st25{fill:#E23237;}\n\t.st26{fill:#B52E31;}\n\t.st27{fill:url(#SVGID_4_);}\n\t.st28{fill:#FFCDE0;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st29{opacity:0.7;}\n\t.st30{opacity:0.1;}\n\t.st31{fill:url(#SVGID_5_);}\n\t.st32{fill:url(#SVGID_6_);}\n\t.st33{fill:url(#SVGID_7_);}\n\t.st34{fill:url(#SVGID_8_);}\n\t.st35{fill:url(#SVGID_9_);}\n\t.st36{fill:#FFB4E6;}\n\t.st37{fill:#535461;}\n\t.st38{fill:#7FC3FF;}\n\t.st39{fill:#F2F2F2;}\n\t.st40{fill:#FFBFE6;}\n\t.st41{fill:#ECFFBF;}\n\t.st42{fill:#E0E0E0;}\n\t.st43{fill:#FFB9B9;}\n\t.st44{fill:#575A89;}\n\t.st45{fill:#FFB4FB;}\n\t.st46{fill:#FF9FF8;}\n\t.st47{fill:#A0616A;}\n\t.st48{fill:#B4E0FF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1299.2,
  y: -429.7,
  className: "st0",
  width: 583.9,
  height: 653.5
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(3.327797e-02 -0.9994 0.9994 3.327797e-02 1264.275 1555.4714)",
  className: "st1",
  cx: 1436.2,
  cy: 124.2,
  rx: 14.9,
  ry: 14.9
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 1408.6,
  cy: 131.3,
  r: 10.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M1980-161.8c29.2-73.6,22.6-156.7-17.9-224.8L1554-330.1l391.1-81.5c-48.2-62.8-122.9-99.6-202.1-99.5 c-140.8,0-255,114.2-255,255c0,11.6,0.8,23.3,2.4,34.8L1980-161.8z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M1355.2-82.2c36.9,95.5,129.5,163.2,238,163.2c101.8,0,189.6-59.6,230.5-145.9L1355.2-82.2z"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 1405.2,
  cy: -317,
  r: 12
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 1837.2,
  cy: -177,
  r: 12
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 1404.2,
  y: -90,
  className: "st5",
  width: 20,
  height: 20
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M1567.2-236c0,0,33-14.4,48.5,0.8S1574.2-225,1567.2-236z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1624.2-304.2c-11.1-18.7-33-19.6-33-19.6s-21.4-2.7-35.1,25.8c-12.8,26.6-30.4,52.3-2.8,58.5l5-15.5l3.1,16.7 c3.9,0.3,7.9,0.3,11.8,0.2c29.5-1,57.7,0.3,56.8-10.3C1628.7-262.5,1634.9-286.2,1624.2-304.2z"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st3",
  cx: 1593.7,
  cy: -31,
  rx: 56,
  ry: 13
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 1584.6,
  y: 130.5,
  transform: "matrix(0.9973 -7.374407e-02 7.374407e-02 0.9973 -5.3103 119.2083)",
  className: "st6",
  width: 54.1,
  height: 2
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 1557.7,
  y: 116.6,
  transform: "matrix(0.4819 -0.8762 0.8762 0.4819 695.3875 1432.0643)",
  className: "st6",
  width: 2,
  height: 22.8
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 1587.7,
  y: 114.5,
  className: "st6",
  width: 18,
  height: 2
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "1540.7,221.6 1538.7,221.4 1553.7,-10.6 1555.7,-10.4 "
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "1614.7,221.5 1604.7,-6.5 1606.7,-6.5 1616.7,221.5 "
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 1642.2,
  y: -8.9,
  transform: "matrix(0.9966 -8.232668e-02 8.232668e-02 0.9966 -3.1895 135.6406)",
  className: "st6",
  width: 2,
  height: 230.8
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M1639.7,35.5c0,0-14,26-23,26s-8,17-6,21s7,13-1,26c-2.8,4.5-2.3,9.7-0.5,14.5c5.1,13.4,25.1,9.3,24.5-5 c0-0.2,0-0.3,0-0.5c-1-16,7-41,15-47s15-22,15-22L1639.7,35.5z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M1543.7,29.5c0,0,14,26,23,26s8,17,6,21s-7,13,1,26c2.8,4.5,2.3,9.7,0.5,14.5c-5.1,13.4-25.1,9.3-24.5-5 c0-0.2,0-0.3,0-0.5c1-16-7-41-15-47s-15-22-15-22L1543.7,29.5z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1554.7-98.5l-6,13c0,0-88,29-80,63s47,87,53,85s38-8,39-25s-23-47-23-47l33-30l48-1l41,31c0,0-43,38-24,53 s47,25,51,19s49-95,42-103s-78-38-78-38l-19-27l-74-4L1554.7-98.5z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M1572.7-263.5c0,0,5,33-5,37s20,21,20,21h17l11-23c0,0-10-18-4-35S1572.7-263.5,1572.7-263.5z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M1572.7-263.5c0,0,5,33-5,37s20,21,20,21h17l11-23c0,0-10-18-4-35S1572.7-263.5,1572.7-263.5z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M1565.7-235.5c0,0,11,12,13,14s11,13,30-3s21,3,21,3v120c0,0-16-7-29,0s-40-2-40-2l-5-124L1565.7-235.5z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M1573-235.5c0,0-9.3-4-17.3,0s-36,24-34,33s28,72,10,102s-21,38-21,38l44-23c0,0,34-21,31-34 S1573-235.5,1573-235.5z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M1612.7-235.5c0,0,21,2,22,4s31.5,10.5,29.5,19.5s-29.5,89.5-17.5,104.5s32,36,25,38s-19-3-31,0s-40-22-37-49 S1603.7-228.5,1612.7-235.5z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M1562.7-44.5v10c0,0-5,23,11,22s6-28,6-28l-1-9L1562.7-44.5z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M1607.7-43.5c0,0-11,23,0,25s19-13,19-17S1607.7-43.5,1607.7-43.5z"
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "1571.7,221.5 1569.7,221.5 1575.7,-8.5 1577.7,-8.5 "
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st7",
  cx: 1622.2,
  cy: -277,
  rx: 2,
  ry: 4
});

var _ref32 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st7",
  cx: 1563.2,
  cy: -277,
  rx: 2,
  ry: 4
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M1639.7-222.5c0,0,25,0,24,10s-34,182-34,182s-14-13-26-10L1639.7-222.5z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M1542.7-219.5c0,0-25,5-25,20s36,159,41,159s24-3,24-8S1542.7-219.5,1542.7-219.5z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M1548.2-190l22.5,88C1570.7-102,1560.2-179,1548.2-190z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M1635.7-202.4l-22.8,115C1613-87.3,1620.2-195.7,1635.7-202.4z"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  className: "st7",
  cx: 1592.7,
  cy: -276.5,
  r: 29
});

var _ref38 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "1619.3,-306 1597.6,-317.4 1567.7,-312.7 1561.5,-285.4 1576.9,-286 1581.2,-296 1581.2,-286.1  1588.3,-286.4 1592.4,-302.4 1595,-285.4 1620.3,-285.9 "
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 1309.2,
  y: 221,
  className: "st13",
  width: 546,
  height: 2
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1763.8,221h-2c0.8-22.2,3.1-44.4,7.1-66.3c8.6-46.9,23-77.7,42.7-91.5l1.1,1.6 C1766.7,97.2,1763.8,219.8,1763.8,221z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1788.8,220.5h-2c0-2.2,1.3-54.4,21.8-68.8l1.1,1.6C1790.1,167.1,1788.8,220,1788.8,220.5z"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 1824.2,
  cy: 54,
  r: 10
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 1819.2,
  cy: 141,
  r: 10
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1784.1,71c1.9,12-3,22.7-3,22.7s-7.9-8.7-9.8-20.7c-1.9-12,3-22.7,3-22.7S1782.2,59,1784.1,71z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1816.8,100.1c-11.5,3.9-22.9,1-22.9,1s7.2-9.3,18.7-13.3c11.5-4,22.9-1,22.9-1S1828.3,96.2,1816.8,100.1z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1817.2,176.3c-5.2,1.6-10.7,1.9-16.1,0.7c6.9-8.8,18.3-12.7,29.2-10C1826.8,171.2,1822.3,174.4,1817.2,176.3z"
});

var _ref47 = /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "1301.2,-235.7 1299.2,-235.7 1299.2,-365 1426.5,-365 1426.5,-363 1301.2,-363 "
});

var _ref48 = /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "1883.1,-237 1881.1,-237 1881.1,-365 1755.1,-365 1755.1,-367 1883.1,-367 "
});

var _ref49 = /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "1301.2,-126.3 1299.2,-126.3 1299.2,3 1426.5,3 1426.5,1 1301.2,1 "
});

var _ref50 = /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "1879.9,-126.3 1878,-126.3 1878,1 1752.6,1 1752.6,3 1879.9,3 "
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  x: 1335.2,
  y: -306,
  className: "st3",
  width: 140,
  height: 2
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 1373.2,
  y: -324,
  className: "st3",
  width: 2,
  height: 18.5
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 1434.2,
  y: -324,
  className: "st3",
  width: 2,
  height: 18.5
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  x: 1713.2,
  y: -165,
  className: "st3",
  width: 140,
  height: 2
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  x: 1751.2,
  y: -183,
  className: "st3",
  width: 2,
  height: 18.5
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  x: 1812.2,
  y: -183,
  className: "st3",
  width: 2,
  height: 18.5
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  x: 1344.2,
  y: -71,
  className: "st3",
  width: 140,
  height: 2
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  x: 1382.2,
  y: -89,
  className: "st3",
  width: 2,
  height: 18.5
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  x: 1443.2,
  y: -89,
  className: "st3",
  width: 2,
  height: 18.5
});

var _ref60 = /*#__PURE__*/React.createElement("rect", {
  className: "st15",
  width: 589.2,
  height: 283
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  x: 818.4,
  y: -386.1,
  className: "st16",
  width: 149.7,
  height: 186.5
});

var _ref62 = /*#__PURE__*/React.createElement("rect", {
  x: 821.6,
  y: -381.9,
  className: "st0",
  width: 143.3,
  height: 178.1
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  x: 826.7,
  y: -375.2,
  className: "st17",
  width: 133,
  height: 164.7
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M917.6-338.6h16.2l-40.6,91.5l-40.6-91.5h31l9.5,21.2l9.3-21.2C902.4-338.6,917.6-338.6,917.6-338.6z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M852.6-338.6l40.6,91.5l40.6-91.5h-16.2l-24.4,54.9l-24.6-54.9H852.6L852.6-338.6z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M868.7-338.6l24.6,55.2l24.4-55.2h-15l-9.3,21.2l-9.5-21.2C883.9-338.6,868.7-338.6,868.7-338.6z"
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  x: 748.9,
  y: -523.6,
  className: "st21",
  width: 196.7,
  height: 112.3
});

var _ref68 = /*#__PURE__*/React.createElement("rect", {
  x: 751.5,
  y: -522.2,
  className: "st0",
  width: 191.5,
  height: 107.5
});

var _ref69 = /*#__PURE__*/React.createElement("rect", {
  x: 757,
  y: -515.5,
  className: "st17",
  width: 180.5,
  height: 94.1
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M1845.5-233.2h6.7c0,0-12.4,17.8-13.4,19.3c-0.4,0.5-0.8,1-1.1,1.6c-0.5,1.6-1,3.3-1.3,5h-6.1 c0,0,1-3.6,0.9-5.5c0-1.7-0.8-3.4-1.3-5c-0.5-1.7-1.1-5-1.1-5h6.3l0.9,3.7L1845.5-233.2"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M1831.8-230.9c1.4,0.8,2.2,5,2.2,5s-7.3,0.1-11.3,0.1h-3.4l-4.2,16.6h-6.4c0,0,4-18,4.9-21.3 c0.3-1.1,2.1-0.9,5.1-0.9h4.8C1826.7-231.4,1830.3-231.7,1831.8-230.9 M1802.2-222.8c0.1-0.8-0.2-1.6-0.7-2.3 c-0.7-1.1-1.4-1.3-3.4-1.4c-5.5-0.2-5.4,3.6-5.4,3.6L1802.2-222.8z M1808.2-227.1c0.8,2.7-0.7,9-0.7,9s-8.1-0.1-12.5,0 c-1.4,0-3-0.1-3.4,0.4c-0.6,0.8,0.2,2.1,0.9,2.6c0.8,0.6,2.3,0.7,2.8,0.7c3.6,0.4,11.1,0.1,11.1,0.1l-1.3,5.3 c0,0-10.6,0.5-15.9-0.7c-1-0.2-2-0.7-2.7-1.3c-0.2-0.2-0.3-0.4-0.5-0.6c-0.3-0.4-0.5-0.7-0.7-1.2c-1.2-3,0.1-8.6,1.5-11.6 c0.2-0.4,0.3-0.8,0.6-1.2c0.3-0.5,0.5-1,0.7-1.3c0.1-0.2,0.3-0.3,0.4-0.5c0.2-0.2,0.3-0.4,0.5-0.6c0.5-0.5,1.1-1,1.7-1.3 c2.2-1.5,6.2-2.7,11-2.2c1.8,0.2,4.5,0.8,5.9,2.5C1807.8-228.5,1808-227.8,1808.2-227.1L1808.2-227.1z M1778.9-231.4h6.2 c0,0-3.4,14.9-5.2,22.2h-7.1c-5,0-9.4,0.6-11.3-2.7c-1.8-3.2-0.1-8.3,0.7-11.9c0.6-2.5,1.8-7.6,1.8-7.6l6.4-0.1 c0,0-1.8,7.9-2.6,11.9c-0.3,1.4-0.8,2.8-0.2,3.8s1.3,1.1,3.7,1.1c0.7,0,3.2,0,3.2,0L1778.9-231.4 M1750-220.6 c0.6-2.1,1.6-4.4,1.5-6.3c-0.2-1.8-1.4-3.4-3.2-4.3c-2.9-0.9-6.1-0.2-8.3,1.8c-1.7,1.7-2.3,3.7-2.9,6.5c-0.5,2.1-0.8,4.2,0,5.8 c1.5,2.8,6.1,2.2,11,2.2C1748.8-216.6,1749.4-218.6,1750-220.6L1750-220.6z M1758.6-228.9c0.7,4.7-2,9.9-3.9,14.4 c1.9,0.2,3.6,0,3.7,0.1c0.1,0.2-1.3,5.4-1.8,5.4c-1.5,0-6.5,0.1-8.6,0.1c-6.8,0-13.2,0.4-16.4-2.7c-1.3-1.4-2.2-3.1-2.5-4.9 c-0.3-2.6,0-5.1,0.7-7.6c0.5-2,1.3-4,2.5-5.8c2.9-4.6,7.8-7.9,16.2-7.2c1.9,0.2,3.7,0.7,5.4,1.6c0.1,0.1,0.5,0.3,0.5,0.4 C1756.4-234.1,1758.2-231.4,1758.6-228.9L1758.6-228.9z M1728.5-231.4c-0.4,1.7-0.8,3.7-1.3,5.3h-6.9c0.5-1.9,0.9-3.7,1.5-5.4 C1724.1-231.4,1726.1-231.4,1728.5-231.4 M1720.1-224.4h6.6c-0.9,4.4-2.6,11.4-3.9,16.4c-0.8,3.1-1.4,5.3-3.7,6.9 c-0.2,0.1-0.3,0.1-0.5,0.2c-0.4,0.4-2.4,0.8-3.4,0.9c-2,0.1-3.9,0.1-5.9,0c0.6-1.9,1.2-4.1,1.7-5.8c5.2,0.6,5.4-3.9,6.4-8.3 C1718-216.7,1719.8-223.4,1720.1-224.4"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M1694.4-211.2l-0.3,0.1c-4.6,1-8.6-0.1-11.1-3.7c-1-1.5-1.6-3.3-1.7-5.2c-0.1-3.1,1-6.5,3.1-9.6 c2.8-4,8-7.8,14-7.2l-1.1,0.2l-0.4,0.2c-10.8,3.8-14.1,16-8.8,22.2C1689.6-212.5,1691.8-211.5,1694.4-211.2"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M1694.5-221.4c1.1,1.7,3.1,2.7,5.5,2.9c-3.7,1.1-7.4-0.3-9.1-4.3c-1.4-3.3,0.6-8.8,4.4-11.7 c2.7-2.1,5-2.5,7.9-2.6c-1,0.2-2,0.5-2.9,1C1693.7-232.5,1692.1-225.3,1694.5-221.4"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M1704.1-224.8c-1,0.3-3.5-0.3-4.1-0.8c-2.5-2.2-2-5-0.7-7.1c0.3-0.4,0.6-0.8,1-1.2c1.3-1.4,3.8-2.7,5.7-2.5 c-1.3,0.4-2.5,1.1-3.5,2c-0.6,0.6-1.1,1.3-1.6,2c-0.5,0.9-0.8,1.9-0.8,2.8c0,0.4,0,0.8,0,1.1 C1700.3-227.6,1700.6-225.8,1704.1-224.8"
});

var _ref75 = /*#__PURE__*/React.createElement("rect", {
  x: 986.7,
  y: -523,
  className: "st24",
  width: 113.1,
  height: 147.9
});

var _ref76 = /*#__PURE__*/React.createElement("rect", {
  x: 989.9,
  y: -518.8,
  className: "st0",
  width: 106.7,
  height: 139.5
});

var _ref77 = /*#__PURE__*/React.createElement("rect", {
  x: 995.1,
  y: -512.1,
  className: "st17",
  width: 96.4,
  height: 126
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M1008.5-475.7l34.8-16.2l35.8,15.9l-5.8,60.2l-30,21.7l-29.5-21.4L1008.5-475.7z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M1079.1-476l-35.8-16v97.8l30-21.7L1079.1-476L1079.1-476z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1043.4-480.5l-21.7,63.1l8.1-0.2l4.4-14.2h19.5l4.8,14.4l7.7,0.2L1043.4-480.5L1043.4-480.5z M1043.5-460.3 l7.3,20H1037L1043.5-460.3z"
});

var _ref81 = /*#__PURE__*/React.createElement("rect", {
  x: 1008.6,
  y: -347.4,
  className: "st27",
  width: 149.7,
  height: 147.9
});

var _ref82 = /*#__PURE__*/React.createElement("rect", {
  x: 1011.8,
  y: -343.2,
  className: "st0",
  width: 143.3,
  height: 139.5
});

var _ref83 = /*#__PURE__*/React.createElement("rect", {
  x: 1016.9,
  y: -336.5,
  className: "st17",
  width: 133,
  height: 126
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1043.3-273.8c0,8,5.9,15.4,15.3,19.7c-1.9,12.3-0.4,22.3,4.7,26.2c5.3,4,13.2,1.3,20.6-7.2 c7.3,8.2,14.6,11.5,19.8,7.6c5.3-4,6.9-14.6,5-27.3c9.8-4.2,15.3-10.5,15.3-18.6c0-7.8-5.9-14.5-15.2-18.8c2.1-13.2,0.4-23-5-27 c-5.2-3.9-12.6-0.6-20,7.8c-7.7-9-15-11.7-20.4-7.7c-5.2,3.9-6.7,14-4.8,26.6C1049.7-288.4,1043.4-281.6,1043.3-273.8z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M1414.3-160.6c-0.8-0.3-1.5-0.7-2.3-1c0.1-0.7,0.3-1.4,0.4-2.1c1.8-11.1,0.7-20-3.2-23 c-3.7-2.8-9.9,0.1-16.1,7.1c-0.6,0.7-1.2,1.4-1.8,2.1c-0.4-0.5-0.8-1-1.2-1.4c-6.5-7.5-12.9-10.7-16.8-7.8 c-3.7,2.8-4.9,11.2-3.3,21.7c0.2,1,0.3,2.1,0.5,3.1c-0.9,0.3-1.8,0.7-2.7,1.1c-7.6,3.4-12.5,8.8-12.5,14.5 c0,5.8,5.2,11.7,13.1,15.2c0.6,0.3,1.3,0.6,1.9,0.8c-0.2,1.1-0.4,2.2-0.6,3.3c-1.5,10.3-0.4,18.5,3.3,21.4c3.8,2.9,10.3,0,16.6-7.2 c0.5-0.6,1-1.2,1.5-1.8c0.6,0.8,1.3,1.6,1.9,2.3c6.1,6.9,12.1,9.7,15.8,6.9c3.9-2.9,5.1-11.7,3.5-22.4c-0.1-0.8-0.3-1.7-0.4-2.5 c0.5-0.2,0.9-0.4,1.3-0.5c8.2-3.5,13.6-9.3,13.6-15.1C1427.1-151.6,1422.1-157.1,1414.3-160.6L1414.3-160.6z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M1412.1-135.1c-0.4,0.2-0.8,0.3-1.2,0.5c-1-4.1-2.2-8-3.6-11.9c1.4-3.8,2.5-7.7,3.5-11.7 c0.7,0.3,1.4,0.6,2.1,0.9c6.6,3,10.7,7.4,10.7,10.8C1423.6-142.8,1419.2-138.1,1412.1-135.1L1412.1-135.1z M1409.1-127.5 c0.7,4.7,0.8,9,0.3,12.4c-0.4,3-1.3,5-2.4,5.8c-2.3,1.7-7.1-0.5-12.3-6.4c-0.6-0.7-1.2-1.4-1.8-2.2c2.2-3.1,4.2-6.5,6-10 c3.3-0.3,6.5-1,9.7-1.9C1408.9-129,1409-128.2,1409.1-127.5L1409.1-127.5z M1379.3-109.7c-2.2,1-4,1-5,0.2 c-2.3-1.7-3.2-8.3-1.9-17.1c0.2-1,0.3-2.1,0.5-3.1c3.2,0.9,6.4,1.5,9.7,1.9c1.9,3.5,3.9,6.8,6.1,10c-0.4,0.6-0.9,1.1-1.4,1.6 C1384.6-113.1,1381.8-110.8,1379.3-109.7L1379.3-109.7z M1369-135.3c-3.5-1.6-6.4-3.6-8.4-5.8c-1.8-2-2.7-4-2.7-5.6 c0-3.4,3.9-7.8,10.4-10.7c0.8-0.4,1.6-0.7,2.5-1c1,4,2.1,8,3.5,11.9c-1.4,3.9-2.6,7.9-3.6,12C1370.2-134.8,1369.6-135,1369-135.3z  M1372.6-166.1c-1.3-9-0.4-15.8,1.8-17.5c2.4-1.8,7.7,0.8,13.3,7.3c0.4,0.4,0.7,0.9,1.1,1.3c-2.2,3.1-4.3,6.4-6.1,9.9 c-3.2,0.4-6.4,1-9.6,1.9C1372.9-164.2,1372.7-165.2,1372.6-166.1L1372.6-166.1z M1403.5-156c-0.7-1.6-1.4-3.2-2.2-4.7 c2.3,0.4,4.5,0.9,6.5,1.5c-0.7,2.7-1.4,5.4-2.3,8.1C1404.9-152.8,1404.2-154.4,1403.5-156L1403.5-156z M1390.9-172.1 c1.5,2.1,2.9,4.4,4.2,6.7c-2.8-0.2-5.6-0.2-8.5,0C1388-167.9,1389.5-170.1,1390.9-172.1L1390.9-172.1z M1378.2-156.1 c-0.7,1.6-1.4,3.2-2,4.8c-0.9-2.8-1.6-5.5-2.3-8.1c2-0.6,4.2-1.1,6.5-1.4C1379.6-159.3,1378.9-157.7,1378.2-156.1z M1380.4-132.2 c-2.2-0.3-4.4-0.8-6.6-1.4c0.6-2.7,1.4-5.4,2.3-8.3c0.6,1.6,1.3,3.3,2,4.9C1378.8-135.4,1379.6-133.7,1380.4-132.2z M1390.9-120.8 c-1.4-2.1-2.9-4.3-4.3-6.8c1.4,0.1,2.8,0.1,4.2,0.1c1.5,0,2.9,0,4.3-0.1C1393.8-125.2,1392.3-122.9,1390.9-120.8z M1405.5-141.9 c0.9,2.7,1.7,5.5,2.4,8.3c-2.2,0.6-4.4,1.1-6.7,1.5c0.8-1.6,1.5-3.2,2.2-4.8C1404.2-138.5,1404.9-140.2,1405.5-141.9z  M1400.8-138.9c-1.1,2.5-2.2,4.9-3.5,7.2c-2.1,0.2-4.3,0.3-6.6,0.3c-2.2,0-4.4-0.1-6.5-0.3c-1.2-2.4-2.4-4.8-3.5-7.3 c-1.1-2.5-2.1-5-3-7.6c1-2.6,2-5.1,3.1-7.5l0,0c1.1-2.5,2.3-4.9,3.5-7.2c2.1-0.2,4.3-0.3,6.5-0.3c2.2,0,4.4,0.1,6.5,0.4 c1.2,2.4,2.4,4.8,3.4,7.2c1.1,2.5,2.1,5,3.1,7.5C1402.9-143.9,1401.9-141.4,1400.8-138.9L1400.8-138.9z M1407.2-183.6 c2.4,1.8,3.3,9.1,1.8,18.7c-0.1,0.6-0.2,1.2-0.3,1.9c-3.2-0.9-6.4-1.6-9.6-2c-1.8-3.5-3.9-6.8-6-9.9c0.5-0.7,1.1-1.3,1.7-2 C1400-183,1405-185.3,1407.2-183.6L1407.2-183.6z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1391.2-154.4c3.5,0,6.4,3.8,6.4,8.4s-2.9,8.4-6.4,8.3c-3.5,0-6.4-3.8-6.4-8.4l0,0 C1384.8-150.7,1387.7-154.4,1391.2-154.4L1391.2-154.4"
});

var _ref88 = /*#__PURE__*/React.createElement("polygon", {
  className: "st31",
  points: "1063.7,-134.3 1063.7,-121.5 1063.7,-117.3 1063.7,-60.5 1063.7,-56.2 1063.7,-44.1 1050.7,-44.1  1046.3,-44.1 1046.3,-56.2 1046.3,-60.5 1046.3,-117.3 1046.3,-121.5 1046.3,-134.3 1050.7,-134.3  "
});

var _ref89 = /*#__PURE__*/React.createElement("polygon", {
  className: "st32",
  points: "1045.2,-134.3 1045.2,-121.5 1045.2,-117.3 1045.2,-60.5 1045.2,-56.2 1045.2,-44.1 1032.2,-44.1  1027.8,-44.1 1027.8,-56.2 1027.8,-60.5 1027.8,-117.3 1027.8,-121.5 1027.8,-134.3 1032.2,-134.3  "
});

var _ref90 = /*#__PURE__*/React.createElement("polygon", {
  className: "st33",
  points: "861.5,-133.6 861.5,-120.8 861.5,-116.6 861.5,-59.8 861.5,-55.5 861.5,-43.4 874.6,-43.4  878.9,-43.4 878.9,-55.5 878.9,-59.8 878.9,-116.6 878.9,-120.8 878.9,-133.6 874.6,-133.6  "
});

var _ref91 = /*#__PURE__*/React.createElement("polygon", {
  className: "st34",
  points: "880,-133.6 880,-120.8 880,-116.6 880,-59.8 880,-55.5 880,-43.4 893,-43.4 897.4,-43.4  897.4,-55.5 897.4,-59.8 897.4,-116.6 897.4,-120.8 897.4,-133.6 893,-133.6  "
});

var _ref92 = /*#__PURE__*/React.createElement("polygon", {
  className: "st35",
  points: "932,-49.3 917.6,-120 917.6,-120 916.8,-124.1 916.8,-124.1 914.3,-136.4 897.5,-130.6 900,-118.2  900,-118.2 900.7,-115 912,-59.2 912,-59.2 912.9,-55.1 912.9,-55.1 915.2,-43.5  "
});

var _ref93 = /*#__PURE__*/React.createElement("rect", {
  x: 1300.3,
  y: -82.1,
  className: "st36",
  width: 16.5,
  height: 85.6
});

var _ref94 = /*#__PURE__*/React.createElement("rect", {
  x: 1300.3,
  y: -70,
  className: "st17",
  width: 16.5,
  height: 4
});

var _ref95 = /*#__PURE__*/React.createElement("rect", {
  x: 1300.3,
  y: -12,
  className: "st17",
  width: 16.5,
  height: 4
});

var _ref96 = /*#__PURE__*/React.createElement("rect", {
  x: 1312.7,
  y: -82.1,
  className: "st8",
  width: 4.1,
  height: 85.6
});

var _ref97 = /*#__PURE__*/React.createElement("rect", {
  x: 1315.2,
  y: -83.4,
  className: "st36",
  width: 16.5,
  height: 85.6
});

var _ref98 = /*#__PURE__*/React.createElement("rect", {
  x: 1314.8,
  y: -70,
  className: "st17",
  width: 16.5,
  height: 4
});

var _ref99 = /*#__PURE__*/React.createElement("rect", {
  x: 1314.8,
  y: -12,
  className: "st17",
  width: 16.5,
  height: 4
});

var _ref100 = /*#__PURE__*/React.createElement("rect", {
  x: 1326.2,
  y: -82.1,
  className: "st8",
  width: 4.1,
  height: 85.6
});

var _ref101 = /*#__PURE__*/React.createElement("polygon", {
  className: "st36",
  points: "1330,-79.2 1345.9,-84.8 1362.8,-2.1 1346.8,3.5  "
});

var _ref102 = /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "1333.4,-62.2 1349.3,-67.8 1350.1,-63.9 1334.2,-58.3  "
});

var _ref103 = /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "1344.2,-11.5 1360.2,-17 1361,-13.1 1345,-7.6  "
});

var _ref104 = /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "1342.4,-83.4 1346.4,-84.8 1363.2,-2.1 1359.2,-0.7  "
});

var _ref105 = /*#__PURE__*/React.createElement("rect", {
  x: 1045,
  y: -131.4,
  className: "st37",
  width: 16.5,
  height: 85.6
});

var _ref106 = /*#__PURE__*/React.createElement("rect", {
  x: 1045,
  y: -119.3,
  className: "st17",
  width: 16.5,
  height: 4
});

var _ref107 = /*#__PURE__*/React.createElement("rect", {
  x: 1045,
  y: -61.3,
  className: "st17",
  width: 16.5,
  height: 4
});

var _ref108 = /*#__PURE__*/React.createElement("rect", {
  x: 1045,
  y: -131.4,
  className: "st8",
  width: 4.1,
  height: 85.6
});

var _ref109 = /*#__PURE__*/React.createElement("rect", {
  x: 1027.4,
  y: -131.4,
  className: "st37",
  width: 16.5,
  height: 85.6
});

var _ref110 = /*#__PURE__*/React.createElement("rect", {
  x: 1027.4,
  y: -119.3,
  className: "st17",
  width: 16.5,
  height: 4
});

var _ref111 = /*#__PURE__*/React.createElement("rect", {
  x: 1027.4,
  y: -61.3,
  className: "st17",
  width: 16.5,
  height: 4
});

var _ref112 = /*#__PURE__*/React.createElement("rect", {
  x: 1027.4,
  y: -131.4,
  className: "st8",
  width: 4.1,
  height: 85.6
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M73.6,191.1c0,31.2-14.2,42.1-31.7,42.1c-0.4,0-0.8,0-1.2,0c-0.8,0-1.6-0.1-2.4-0.1 c-15.8-1.5-28-12.9-28-41.9c0-30,29.3-67.9,31.5-70.7l0,0c0.1-0.1,0.1-0.2,0.1-0.2S73.6,159.9,73.6,191.1z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M41.4,228.4L53,207.2l-11.6,23.5v2.4c-0.8,0-1.6-0.1-2.4-0.1l1.2-31.2v-0.2l0,0l0.1-2.9l-11.6-23.5l11.7,21.2 v0.6l0.9-23.6l-10-24.3l10.1,20.2l1-48.8v-0.2v0.2L42.2,159l9.9-15.3l-10,18.6l-0.3,21.1l9.3-20.2l-9.2,23.3l-0.1,11.7L55.2,170 l-13.5,32.3L41.4,228.4z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  className: "st40",
  d: "M125.4,235.1c0,18.7-8.5,25.2-19,25.2c-0.2,0-0.5,0-0.7,0c-0.5,0-1,0-1.4-0.1c-9.5-0.8-16.9-7.7-16.9-25.1 c0-18,17.6-40.7,18.9-42.3l0,0c0.1-0.1,0.1-0.1,0.1-0.1S125.4,216.5,125.4,235.1z"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M106.1,257.5l6.9-12.7l-7,14.1v1.5c-0.5,0-1,0-1.4-0.1l0.7-18.7v-0.1l0,0l0.1-1.8l-7-14.1l7,12.8v0.4 l0.6-14.1l-6-14.6l6,12.1l0.6-29.3v-0.1v0.1l-0.1,23.1l5.9-9.2l-6,11.1l0,12.6l5.5-12.1l-5.6,14l-0.1,7l8.2-16.9l-8.1,19.3 L106.1,257.5z"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  className: "st41",
  d: "M91.1,258h30.6c4.2,0,7.5,4.4,7.5,9.9v5.7c0,5.4-3.4,9.9-7.5,9.9H91.1c-4.2,0-7.5-4.4-7.5-9.9v-5.7 C83.6,262.4,87,258,91.1,258z"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  className: "st41",
  d: "M12,233.5h59.8c0,0,11.8,19.7-6.5,49H18.1C18.1,282.5,1,262.2,12,233.5z"
});

var _ref119 = /*#__PURE__*/React.createElement("g", {
  className: "st30"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1144.5-86.7h-59.8c-0.1,0.4-0.3,0.7-0.4,1.1h58.2c0,0,11.5,19.2-5.9,47.9h1.4C1156.3-67,1144.5-86.7,1144.5-86.7z"
}));

var _ref120 = /*#__PURE__*/React.createElement("rect", {
  x: 746.2,
  y: -46.5,
  className: "st42",
  width: 414.9,
  height: 18.4
});

var _ref121 = /*#__PURE__*/React.createElement("rect", {
  x: 763.8,
  y: -28.2,
  className: "st42",
  width: 379.8,
  height: 7.5
});

var _ref122 = /*#__PURE__*/React.createElement("rect", {
  x: 763.8,
  y: -28.2,
  className: "st8",
  width: 379.8,
  height: 2.5
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M282.7,155.4c0,42.9-28.5,57.9-63.6,57.9c-0.8,0-1.6,0-2.4,0c-1.6,0-3.2-0.1-4.8-0.1 c-31.7-2.1-56.1-17.7-56.1-57.6c0-41.2,58.8-93.4,63.2-97.2l0,0c0.2-0.1,0.2-0.3,0.2-0.3S282.7,112.5,282.7,155.4z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M218.1,206.7l23.3-29.2l-23.3,32.3v3.3c-1.6,0-3.2-0.1-4.8-0.1l2.4-42.9v-0.3l0,0l0.2-4l-23.3-32.3l23.5,29.2 v0.8l1.8-32.4l-20.1-33.4l20.3,27.8l2-67.1v-0.3v0.3l-0.4,52.9l19.9-21l-20.1,25.6l-0.6,29l18.6-27.8l-18.4,32l-0.2,16.1l26.9-38.8 l-27.1,44.4L218.1,206.7z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M386.6,215.9c0,25.7-17,34.7-38.1,34.7c-0.4,0-1,0-1.4,0c-1,0-2,0-2.8-0.1c-19.1-1.1-33.9-10.6-33.9-34.5 c0-24.7,35.3-56,37.9-58.2l0,0c0.2-0.1,0.2-0.1,0.2-0.1S386.6,190.4,386.6,215.9z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M347.9,246.7l13.8-17.5l-14,19.4v2.1c-1,0-2,0-2.8-0.1l1.4-25.7v-0.1l0,0l0.2-2.5l-14-19.4l14,17.6v0.6 l1.2-19.4l-12-20.1l12,16.6l1.2-40.3v-0.1v0.1l-0.2,31.8l11.8-12.7l-12,15.3l0,17.3l11-16.6l-11.2,19.3l-0.2,9.6l16.4-23.2 l-16.2,26.5L347.9,246.7z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "st41",
  d: "M317.8,247.4h61.4c8.4,0,15,6.1,15,13.6v7.8c0,7.4-6.8,13.6-15,13.6h-61.4c-8.4,0-15-6.1-15-13.6V261 C302.8,253.5,309.6,247.4,317.8,247.4z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "st41",
  d: "M159.2,213.7h119.9c0,0,23.7,27.1-13,67.4h-94.7C171.4,281.1,137.1,253.2,159.2,213.7z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M493.2,143.7c0,47.6-23.4,64.2-52.2,64.2c-0.7,0-1.3,0-2,0c-1.3,0-2.6-0.2-4-0.2c-26-2.3-46.1-19.7-46.1-63.9 c0-45.7,48.3-103.5,51.9-107.8l0,0c0.2-0.2,0.2-0.3,0.2-0.3S493.2,96.1,493.2,143.7z"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M440.1,200.5l19.1-32.3l-19.1,35.8v3.7c-1.3,0-2.6-0.2-4-0.2l2-47.6v-0.3l0,0l0.2-4.4l-19.1-35.8l19.3,32.3 v0.9l1.5-36l-16.5-37l16.6,30.8l1.6-74.4v-0.3v0.3l-0.3,58.7l16.3-23.3l-16.5,28.4l-0.5,32.2l15.3-30.8L441,136.7l-0.2,17.8 l22.1-43l-22.2,49.2L440.1,200.5z"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M578.5,210.8c0,28.5-14,38.4-31.3,38.4c-0.3,0-0.8,0-1.2,0c-0.8,0-1.6,0-2.3-0.2 c-15.7-1.2-27.8-11.7-27.8-38.3c0-27.4,29-62,31.1-64.5l0,0c0.2-0.2,0.2-0.2,0.2-0.2S578.5,182.4,578.5,210.8z"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M546.7,244.9l11.4-19.4L546.6,247v2.3c-0.8,0-1.6,0-2.3-0.2l1.2-28.5v-0.2l0,0l0.2-2.7L534,196.3l11.5,19.5 v0.6l1-21.5l-9.9-22.3l9.9,18.4l1-44.7v-0.2v0.2l-0.2,35.2l9.7-14l-9.9,16.9v19.2l9.1-18.4l-9.2,21.3l-0.2,10.7l13.5-25.8 L547.1,221L546.7,244.9z"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  className: "st41",
  d: "M522,245.7h50.4c6.9,0,12.4,6.7,12.4,15.1v8.7c0,8.2-5.6,15.1-12.4,15.1H522c-6.9,0-12.4-6.7-12.4-15.1v-8.7 C509.7,252.4,515.3,245.7,522,245.7z"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  className: "st41",
  d: "M391.7,208.3h98.5c0,0,19.4,30-10.7,74.7h-77.8C401.7,283,373.6,252.1,391.7,208.3z"
});

var _ref135 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st43",
  points: "1539.4,-523.8 1520.2,-525 1526.6,-497.9 1548.3,-506.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "1715.5,-574.4 1670.7,-615.3 1645,-596.7 1594.4,-539.4 1600.2,-531 1661.7,-570.2 1703.3,-518.9  1743,-537.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "1715.5,-574.4 1670.7,-615.3 1645,-596.7 1594.4,-539.4 1600.2,-531 1661.7,-570.2 1703.3,-518.9  1743,-537.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M1719.3-547.3l-5.8,4.2l-46.8-15.1l-10.9-4.2l-21.8,4.2c0,0,0-16.9,20.5-16.3l21.1,4.8l25,1.8L1719.3-547.3z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "1761,-502.7 1746.9,-494.2 1730.2,-494.2 1652.7,-521.4 1539.4,-502.1 1536.2,-525 1639.9,-567.7  1730.9,-539.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M1670-609.9l-9.6,1.8l-2.1-2.3c-3.4-3.7-4.1-9-1.7-13.4l0,0l26.9-33.1c0,0,7.7-16.3,19.9-9.6 c12.2,6.6-10.2,17.5-10.2,17.5l-13.4,19.9l1.3,10.2L1670-609.9z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st43",
  cx: 1730.9,
  cy: -672.6,
  rx: 25,
  ry: 23.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M1719.6-655.4l11.5,25.9l27.5-10.8c0,0-9-20.5-9-21.1C1749.6-662,1719.6-655.4,1719.6-655.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st44",
  d: "M1795.5-578.8c0,14.2-2.4,28.3-7,41.8l-1.9,5.4l-9,38.6l-9.6,2.4l-7-8.4l-14.1-9.6l-10.2-15.7l-8.8-13.8 l-2.7-4.3l-9.6-45.2l-36.5-19.3l-12.2-1.8l2.6-6.6l10.9-13.9l10.9-1.2l3.2-2.4l2.6,1.2l10.1-5.4l3.2,1.2l18.7,1.6l11.4-2.2 l16.4-8.3l6.7,1l23.1,18.1C1792.5-610.6,1795.5-594.7,1795.5-578.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1526.1-514.4c0,0,5.7-9.1,3.3-10.2c-2.4-1.1-12.7-5.3-12.7-5.3l-15.1-4.7c0,0-21.8-30.4-22.3-4 c-0.5,26.4,15.9,32.8,15.9,32.8s14.6,29.5,22.8,24.8c8.3-4.7,16.5-20.7,16.5-20.7S1519.6-509.2,1526.1-514.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "1788.5,-584 1764.2,-569 1727.8,-538.1 1725.1,-542.4 1717.4,-578.6 1719.3,-578.6 1739.2,-612.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st44",
  points: "1739.2,-616.6 1719.3,-582.2 1712.3,-582.2 1707.8,-570.2 1697.6,-567.7 1725.1,-539.4  1764.2,-572.6 1788.5,-587.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M1711.4-690.1l-2.7,1c-1.7-1.1-2.2-3.3-1-4.9c0,0,0,0,0-0.1l-5-0.2c12.5-15.7,36.2-18.9,52.9-7.1 c1.2,0.9,2.4,1.8,3.5,2.8c0.2-0.7,2.7,0.7,3.7,2.2c0.3-1.2,2.7,4.6,3.5,8.7c0.4-1.4,1.8,0.8,0.6,3c0.8-0.1,1.2,1.8,0.6,2.9 c0.9-0.4,0.7,1.9-0.2,3.5c1.3-0.1-10,16.4-14.6,26c-1.3-5.7-2.8-11.8-7.1-16c-0.7-0.7-1.5-1.4-2.3-2l-4.3-3.6 c-5-4.2-9.5-9.3-16.2-10.8c-4.6-1.1-7.5-1.3-5-6.2c-2.3,0.9-4.4,2.2-6.6,3C1711.2-688.6,1711.5-689.4,1711.4-690.1z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st43",
  cx: 1743.3,
  cy: -669.9,
  rx: 4.5,
  ry: 4.2
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 1464.9,
  y: -362.7,
  className: "st45",
  width: 21.7,
  height: 20.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M1496.3-350.3H1470v-24.8h26.3V-350.3z M1471.1-351.4h24V-374h-24V-351.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st46",
  points: "1422,-329.2 1428,-309.6 1407.2,-304 1401.2,-323.6  "
}), /*#__PURE__*/React.createElement("path", {
  d: "M1412.9-309.2l-7.2-23.8l25.3-6.8l7.2,23.8L1412.9-309.2z M1407.1-332.2l6.6,21.7l23.1-6.2l-6.6-21.7L1407.1-332.2z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st45",
  points: "1448.5,-415.8 1433.7,-400.9 1417.9,-414.8 1432.7,-429.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M1411.2-400.3l18-18.1l19.2,16.9l-18,18.1L1411.2-400.3z M1429.2-416.8l-16.4,16.5l17.6,15.4l16.4-16.5 L1429.2-416.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M2273.7-804.2h-201.4v-3.9H1981v3.9h-202.2c-7.5,0-13.6,5.7-13.6,12.8l0,0V-532c0,7.1,6.1,12.8,13.6,12.8h495 c7.5,0,13.6-5.7,13.6-12.8v-259.4C2287.3-798.5,2281.2-804.2,2273.7-804.2L2273.7-804.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1783.4,
  y: -781.6,
  className: "st17",
  width: 485.7,
  height: 257.7
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st17",
  cx: 2025.8,
  cy: -793.3,
  rx: 5,
  ry: 4.7
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "2130.2,-523.9 1783.4,-523.9 1783.4,-781.6  "
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st39",
  cx: 1859.4,
  cy: -587.1,
  rx: 46.7,
  ry: 43.9
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M1869.8-554c-32.1,0-58.1-24.5-58.1-54.6c0-30.2,26-54.6,58.1-54.6c32.1,0,58.1,24.5,58.1,54.6 C1927.8-578.5,1901.9-554.1,1869.8-554z M1869.8-662.6c-31.7,0-57.3,24.1-57.3,53.9s25.7,53.9,57.3,53.9 c31.7,0,57.3-24.1,57.3-53.9C1927.1-638.4,1901.4-662.6,1869.8-662.6L1869.8-662.6z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2139.1,
  y: -642.6,
  className: "st3",
  width: 45.4,
  height: 8.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 2084.3,
  y: -712,
  className: "st3",
  width: 155.1,
  height: 3.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 2084.3,
  y: -699.9,
  className: "st3",
  width: 155.1,
  height: 3.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 2084.3,
  y: -687.8,
  className: "st3",
  width: 155.1,
  height: 3.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 2084.3,
  y: -675.7,
  className: "st3",
  width: 155.1,
  height: 3.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 2084.3,
  y: -663.6,
  className: "st3",
  width: 155.1,
  height: 3.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 2220.4,
  y: -776.4,
  className: "st39",
  width: 19,
  height: 17.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M2248.2-750.2h-23v-21.7h23V-750.2z M2226.1-751.2h21V-771h-21V-751.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M2301-528.5h-47.4v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2 c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3 c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2H2142v-3.2 c0-0.4-0.3-0.6-0.7-0.6l0,0H2125c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3 c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0H1959c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.1v-3.2 c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3 c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2 c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-9.6v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3 c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-10.2v-3.2c0-0.4-0.3-0.6-0.7-0.6l0,0h-16.3c-0.4,0-0.7,0.3-0.7,0.6l0,0v3.2h-31.1 c-9,0-16.3,6.8-16.3,15.3v6.9c0,8.4,7.3,15.3,16.3,15.3h540.3c9,0,16.3-6.8,16.3-15.3v-6.9C2317.2-521.7,2310-528.5,2301-528.5z"
}));

var _ref136 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M1181.6,647.2c0,25.7-138.8,46.5-310,46.5s-310-20.8-310-46.5c0-18.2,69.6-33.9,171-41.6 c41.8-3.2,89-4.9,139-4.9c20.5,0,40.6,0.3,60,0.9C1074.1,605.7,1181.6,624.6,1181.6,647.2z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st8",
  cx: 831.6,
  cy: 642.2,
  rx: 119,
  ry: 14.5
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st3",
  cx: 831.1,
  cy: 532.7,
  rx: 112.5,
  ry: 120
}), /*#__PURE__*/React.createElement("rect", {
  x: 796.6,
  y: 603.7,
  className: "st17",
  width: 70,
  height: 64
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st44",
  points: "958.1,619.2 954.1,641.2 980.1,645.2 997.1,635.2 996.1,619.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st47",
  d: "M827.1,206.2c0,0-2,23-7,24s11,41,11,41h24l19-5l-9-22c0,0-12-16-3-29S827.1,206.2,827.1,206.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M827.1,206.2c0,0-2,23-7,24s11,41,11,41h24l19-5l-9-22c0,0-12-16-3-29S827.1,206.2,827.1,206.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M777.1,382.2c0,0-26,50-5,60s26,9,26,12s-4,2-2,7s-4,25,2,37s4,21,4,21s0,1,2,5s3,7,2,9s-7,15-1,18s37,5,40,0 s-3-8,0-11s5-4,3-6s-4-27-4-27s5-29,3-33s-5-8-3-11s4-2,5-6s3-13,3-13l11-1l26,5c0,0,29,32,61,42c0,0,9,9,12,9s3,0,2,2s-4,2-2,4 s5-1,3,2s-4,3-2,5s-1,13-1,14s-9,95-6,97s45,8,48,0s-2-18-2-18s15-120,11-128s-18-44-93-67c0,0-21-4-21-7s-2-22-6-23s-27-2-27-2 l-29,9l-40-7L777.1,382.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M812.1,550.2l-5,18c0,0-4,29,1,36c3.9,5.5,10.9,12.2,23.9,13.4c7.5,0.7,14.5-3.9,16.8-11.1 c0.1-0.4,0.2-0.9,0.3-1.3c0-2-3-26-3-26l-5-25l-1-7L812.1,550.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M958.1,636.2c0,0-5-5-6,0s-5,26,2,27s74,11,81,7s20-10,12-13s-31-12-31-12s-13-17-15-18s-13,1-18,5 S958.1,636.2,958.1,636.2z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st47",
  cx: 851.1,
  cy: 196.2,
  r: 31
}), /*#__PURE__*/React.createElement("path", {
  className: "st44",
  d: "M848.1,266.2l-12-13l-13.3-26c0,0-9.7-3-11.7,2s-38,21-38,21s9,84,5,92s-11,40-5,43s34,0,43,4s35,4,42-1 s9-9,16-6c6,2.6,19.9-84.8,23.9-110.8c0.7-4.5-1.2-8.9-4.9-11.5c-9-6.3-25.1-17.1-28-15.7C861.1,246.2,848.1,266.2,848.1,266.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st44",
  d: "M891.1,262.2L891.1,262.2c4.8,1.2,8.4,5.3,8.9,10.2l8.1,72.8c0,0-20,43-30,14S891.1,262.2,891.1,262.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st44",
  d: "M889.1,352.2l22-6c0,0,4,28,8,28s-14,16-23,14s-22-9-23-14s9-26,9-26L889.1,352.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M827.7,209.5c2.1-4.6,1.7-10.1,3.5-14.9c3.3-9.2,13.5-14,22.7-10.6c1.5,0.5,2.9,1.3,4.2,2.2 c2.2,1.6,4.5,3.8,7.2,3.5c2.9-0.3,5.6-3.6,8.3-2.4c3,1.3,2.2,6.7,5.2,8c1.6,0.7,3.5-0.4,4.4-1.8c0.8-1.5,1.2-3.2,1.3-5 c0.4-4.3,0.8-8.8-1.1-12.6c-0.8-1.3-1.5-2.7-2-4.1c-0.3-1.3-0.5-2.7-0.4-4c0-5-0.4-10.2-2.9-14.6c-2.8-4.8-8-7.9-13.4-9.2 c-5.4-1.3-11.1-1.1-16.6-0.7c-9.2,0.8-18.7,2.4-25.9,8.1c-1,0.7-1.8,1.6-2.5,2.6c-0.6,1.2-1.1,2.5-1.3,3.8 c-1.6,6.4-3.9,12.5-7,18.3c-1.5,2.5-2.7,5.1-3.6,7.8c-0.8,2.8-0.7,5.9,0.9,8.3c1.3,1.9,3.4,3,5,4.5c1.6,1.6,2.4,4.6,4.2,5.7 c1.6,1,3.5,0.3,5.1,1.4C825.1,205.3,825.2,208.4,827.7,209.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M853.1,281.2l3-6c0,0,44,13,53,25c0,0,22-14,34-12l12,2l-37,33l-47-4L853.1,281.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M851.1,275.2l-41,57l59,29c0,0,5.5,3,9.8,0l39.2-18l37-53l-37,19c0,0-4-8-12-4L851.1,275.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st47",
  d: "M914.1,376.2l8-21c0,0,18-23,8-34s-21,32-21,32L914.1,376.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st47",
  d: "M821.8,372.8l17.5-14.2c0,0,27.1-10.9,24-25.4c-3.1-14.5-34.2,17.1-34.2,17.1L821.8,372.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M778.6,271.7h-1c0,0-15.5-18.5-18.5,6.5s-13,108,13,111s44.5-12.5,44.5-12.5s19-29,12-29c-3.4,0-12.6-1.5-21-1 c-9,0.6-17,3.1-16.5,0.5C792.1,342.2,806.6,278.7,778.6,271.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st44",
  d: "M777.1,252.2l-4-2c0,0-16,3-19,28s-13,108,13,111s61-4,61-4s7-38,0-38s-43,5-42,0S805.1,259.2,777.1,252.2z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st44",
  points: "899.6,364.7 910.6,347.8 917.6,375.7 899.6,383.7  "
}), /*#__PURE__*/React.createElement("circle", {
  className: "st39",
  cx: 673,
  cy: 96.7,
  r: 27
}), /*#__PURE__*/React.createElement("rect", {
  x: 641,
  y: 297.7,
  className: "st39",
  width: 64,
  height: 64
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st39",
  points: "933.6,11.6 949.8,39.6 966,67.7 933.6,67.7 901.2,67.7 917.4,39.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M1215.8,179.8c-0.4,12-3.3,21.6-8.7,28.8s-11.9,10.8-19.4,10.8c-6.1,0-11.4-3.5-16-10.6 c-4.6-7.1-6.9-17.9-6.9-32.6c0-3.2,0.1-6.3,0.2-9.3c0.2-2.9,0.3-5.7,0.6-8.3l4.1-38.1h-26.8c-4.6,48.2-8.4,76.9-11.4,86 c-3,9.2-8,13.7-15.1,13.7c-3.2-0.1-6.3-1.4-8.6-3.6c-2.7-2.4-4.2-5.9-4.1-9.5c0-3.6,2.8-8.5,8.4-14.9s8.7-12.2,9.3-17.4l6.9-54.3 h-11.2c-3.2,0-6.3,0.8-9.1,2.3c-2.6,1.2-4.8,3-6.5,5.3l-5,7.4h-4.1c3.8-11.7,8.4-20.6,14-26.5c5.5-5.9,11.9-8.9,19.1-8.9h88.5v20.4 h-29.9c-0.9,9.3-1.6,18.5-2.1,27.8s-0.8,18.6-0.8,27.9c0,6.3,1.5,11.5,4.4,15.4s6.6,5.9,11,5.9c2.7,0,5.5-1.1,8.5-3.3 c2.9-2,4.7-5.2,5-8.6c0.2-1.7,0.4-3,0.5-4s0.2-1.6,0.2-1.8L1215.8,179.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M1215.8,179.8c-0.4,12-3.3,21.6-8.7,28.8s-11.9,10.8-19.4,10.8c-6.1,0-11.4-3.5-16-10.6 c-4.6-7.1-6.9-17.9-6.9-32.6c0-3.2,0.1-6.3,0.2-9.3c0.2-2.9,0.3-5.7,0.6-8.3l4.1-38.1h-26.8c-4.6,48.2-8.4,76.9-11.4,86 c-3,9.2-8,13.7-15.1,13.7c-3.2-0.1-6.3-1.4-8.6-3.6c-2.7-2.4-4.2-5.9-4.1-9.5c0-3.6,2.8-8.5,8.4-14.9s8.7-12.2,9.3-17.4l6.9-54.3 h-11.2c-3.2,0-6.3,0.8-9.1,2.3c-2.6,1.2-4.8,3-6.5,5.3l-5,7.4h-4.1c3.8-11.7,8.4-20.6,14-26.5c5.5-5.9,11.9-8.9,19.1-8.9h88.5v20.4 h-29.9c-0.9,9.3-1.6,18.5-2.1,27.8s-0.8,18.6-0.8,27.9c0,6.3,1.5,11.5,4.4,15.4s6.6,5.9,11,5.9c2.7,0,5.5-1.1,8.5-3.3 c2.9-2,4.7-5.2,5-8.6c0.2-1.7,0.4-3,0.5-4s0.2-1.6,0.2-1.8L1215.8,179.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st48",
  d: "M1801.7-16.1c-0.1,5-1.3,9-3.3,12c-2.1,3-4.5,4.5-7.3,4.5c-2.3,0-4.3-1.5-6.1-4.4c-1.7-3-2.6-7.5-2.6-13.6 c0-1.4,0-2.7,0.1-3.9c0.1-1.2,0.1-2.4,0.2-3.5l1.5-16h-10.1c-1.8,20.2-3.2,32.2-4.3,36s-3,5.7-5.7,5.7c-1.2,0-2.4-0.6-3.2-1.5 c-1-1-1.6-2.5-1.5-4c0-1.5,1.1-3.6,3.2-6.2c2.1-2.7,3.3-5.1,3.5-7.3l2.6-22.7h-4.3c-1.2,0-2.4,0.3-3.4,0.9c-1,0.5-1.8,1.3-2.5,2.2 l-1.9,3.1h-1.5c1.4-4.9,3.2-8.6,5.3-11.1s4.5-3.7,7.2-3.7h33.5v8.5h-11.3c-0.4,3.9-0.6,7.8-0.8,11.6c-0.2,3.9-0.3,7.8-0.3,11.7 c0,2.7,0.6,4.8,1.7,6.4c1.1,1.6,2.5,2.5,4.2,2.5c1,0,2.1-0.5,3.2-1.4c1.1-0.8,1.8-2.2,1.9-3.6c0.1-0.7,0.2-1.3,0.2-1.7 c0-0.4,0.1-0.7,0.1-0.8L1801.7-16.1z"
}));

var SvgKhi = function SvgKhi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb414a8b-d0ff-4841-818a-532ec941ba8d",
    x: "0px",
    y: "0px",
    viewBox: "0 0 589.2 283.5",
    style: {
      enableBackground: "new 0 0 589.2 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, /*#__PURE__*/React.createElement("g", null, _ref60, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 907.2979,
    y1: 1426.4,
    x2: 907.2979,
    y2: 1239.9,
    gradientTransform: "matrix(1 0 0 1 -14.0479 -1626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 861.2979,
    y1: 1214.7,
    x2: 861.2979,
    y2: 1102.4,
    gradientTransform: "matrix(1 0 0 1 -14.0479 -1626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref67), _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1057.298,
    y1: 1250.9,
    x2: 1057.298,
    y2: 1103,
    gradientTransform: "matrix(1 0 0 1 -14.0479 -1626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1097.4979,
    y1: 1426.5,
    x2: 1097.4979,
    y2: 1278.6,
    gradientTransform: "matrix(1 0 0 1 -14.0479 -1626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.9367,
    y1: 1666.9,
    x2: 502.9367,
    y2: 1576.7,
    gradientTransform: "matrix(-1 0 0 1 1557.9368 -1711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref88), /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.4368,
    y1: 1666.9,
    x2: 521.4368,
    y2: 1576.7,
    gradientTransform: "matrix(-1 0 0 1 1557.9368 -1711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref89)), /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 884.2479,
    y1: 1582.6,
    x2: 884.2479,
    y2: 1492.4,
    gradientTransform: "matrix(1 0 0 1 -14.0479 -1626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref90), /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 902.7479,
    y1: 1582.6,
    x2: 902.7479,
    y2: 1492.4,
    gradientTransform: "matrix(1 0 0 1 -14.0479 -1626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref91), /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 928.7979,
    y1: 1582.5,
    x2: 928.7979,
    y2: 1489.6,
    gradientTransform: "matrix(1 0 0 1 -14.0479 -1626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref92)), _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134), _ref135, _ref136);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKhi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/khi.203e16bc.svg";
export { ForwardRef as ReactComponent };